export class DmVersion {
   public static readonly version: string =  '3.0.12';
}
